// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App';
// import store from './store';
import Router from 'vue-router'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import httpRequest from '@/utils/httpRequest'
import VueCookie from 'vue-cookie'            // api: https://github.com/alfhen/vue-cookie
// import 'font-awesome/css/font-aswesome.min.css'
// 导入 crypto-js 包 
import cryptoJS from 'crypto-js/crypto-js'
//把AES加密vue原型里
Vue.prototype.$cryptoJS = cryptoJS;
Vue.config.productionTip = false
Vue.use(Router)
Vue.use(ElementUI)
Vue.use(VueCookie)

// 手动转换
import './utils/rem'
// 挂载全局
Vue.prototype.$http = httpRequest // ajax请求方法

//全局属性
// Vue.prototype.$ImgShow = process.env.IMG_SHOW_URL
import * as filters from '@/utils/filters'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js